import { defineComponent as _defineComponent } from 'vue'
import VTabs from "../components/tabs.vue"
import VTab from "../components/tab.vue"
import InviteLink from '../components/invite-link.vue'
import Loader from '@/components/loader.vue';
import OptOffer from '@/components/opt-offer.vue'
import MeetingLinkPopup from '@/components/meeting-link-popup.vue'
import MeetingLinkSharePopup from '@/components/meeting-link-share-popup.vue'
import PopupVideo from '@/components/popup-video.vue';
import Toast from "@/components/toast.vue"

import { useRoute, useRouter } from 'vue-router';
import { ref, computed, onMounted } from 'vue'
import { InviteLinks, DataInstance, Userspaces } from '@busy-human/opt-library'
import { useUserspace } from "@/store/userspace";
import { useInvites } from "@/store/invites";


export default /*#__PURE__*/_defineComponent({
  __name: 'active-links',
  setup(__props, { expose }) {
  expose();

const tabIndex = ref(0)
const noScroll = ref(false)
const loading = ref(false)

const showToast = ref<boolean>(false)
const toastMessage = ref<string>("")

const showVideo = ref(false)
const showPopup = ref<boolean>(false)
const showSharePopup = ref<boolean>(false)
const showPreview = ref<boolean>(false)

const selectedLink = ref<DataInstance<InviteLinks.Model>>()

const route = useRoute();
const router = useRouter();
const goTo = (route: string) => {
    router.push(route)
}

onMounted(()=> {
    if(route.query?.showToast === 'true'){
        handleToast('newLink')
    }
})


const invites = useInvites();
const userInviteLinks = computed(() => invites.links);



const openPopup = (value: DataInstance<InviteLinks.Model>) =>{
    selectedLink.value = value
    showPopup.value = true
}

const openSharePopup = (value: DataInstance<InviteLinks.Model>) =>{
    selectedLink.value = value
    showSharePopup.value = true
}

const handlePreview = () => {
    showPreview.value = true
}

const updateActive = (linkId: string, active: boolean) => {
    // console.log("Called", linkId,active)
    InviteLinks.Collection.updateDoc(linkId, {
        active: active
    })
}

const updateInvite = (linkId: string, props: {name: string, note: string, contactInfo: string}) => {
    // console.log("Called", linkId, props)
    InviteLinks.Collection.updateDoc(linkId, props)
}

const deleteLink = async (linkId: string) => {
    showPopup.value = false;
    loading.value = true
    await InviteLinks.Collection.deleteDoc(linkId)
    loading.value = false
}

const handleToast = (value: "share" | "copy" | "embed" | "newLink" | "cantCopy") =>{
    if(value == 'embed'){
        toastMessage.value = "Copied Embed Link to Clipboard!"
    }else if(value == 'share'){
        toastMessage.value = "Copied Share Link to Clipboard!"
    }else if(value == 'copy'){
        toastMessage.value = "Copied Invite Link to Clipboard!"
    }else if(value == 'newLink'){
        toastMessage.value = "Meeting Type Successfully Created!"
    }else if(value == 'cantCopy'){
        toastMessage.value = "WARNING: Unable to copy link in non https/localhost domain"
    }else{
        toastMessage.value = "Copied Link to Clipboard!"
    }
    showToast.value = true;
    setTimeout(()=>{
        showToast.value = false
    },5000)
}


const __returned__ = { tabIndex, noScroll, loading, showToast, toastMessage, showVideo, showPopup, showSharePopup, showPreview, selectedLink, route, router, goTo, invites, userInviteLinks, openPopup, openSharePopup, handlePreview, updateActive, updateInvite, deleteLink, handleToast, VTabs, VTab, InviteLink, Loader, OptOffer, MeetingLinkPopup, MeetingLinkSharePopup, PopupVideo, Toast, useRoute, useRouter, ref, computed, onMounted, InviteLinks, DataInstance, Userspaces, useUserspace, useInvites }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})